import { createSlice } from "@reduxjs/toolkit";

// Then, handle actions in your reducers:
const sideBarSlice = createSlice({
  name: "sideBar",
  initialState: false,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    hideSideBar() {
      return false;
    },
    showSideBar() {
      return true;
    },
    toggleSideBar(state) {
      return !state;
    },
  },
});

export const { hideSideBar, showSideBar, toggleSideBar } = sideBarSlice.actions;
export default sideBarSlice.reducer;
